import { render, staticRenderFns } from "./ActiveLabel.vue?vue&type=template&id=79e69d3e&lang=true&"
import script from "./ActiveLabel.vue?vue&type=script&lang=js&"
export * from "./ActiveLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports